import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { emailValidator, matchingPasswords } from 'src/app/theme/utils/app-validators';
import { AppService } from 'src/app/app.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  passwordResetFrom: FormGroup;
  constructor(public formBuilder: FormBuilder, public router: Router, public snackBar: MatSnackBar,
    private appService: AppService, private _authService: AuthenticationService,
    private _router: Router, private token: TokenStorageService) { }

  ngOnInit() {
    this.passwordResetFrom = this.formBuilder.group({
      'password': ['', Validators.required],
      'confirmPassword': ['', Validators.required]
    }, { validator: matchingPasswords('password', 'confirmPassword') });

  }
  public onResetPassword(values: Object): void {
    if (this.passwordResetFrom.valid) {
      this.appService.changePassword("api/User/ChangePassword", values).subscribe(data => {
        this.snackBar.open('Password changed successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
        this.logout();
      });
      // this.router.navigate(['/']);
    }
  }
  public logout = () => {

    this._authService.logout();
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    this._router.onSameUrlNavigation = 'reload';
    this._router.navigate(["/"]);
  }
}

